import { render, staticRenderFns } from "./MeusHorariosPage.vue?vue&type=template&id=561ad000"
import script from "./MeusHorariosPage.vue?vue&type=script&lang=js"
export * from "./MeusHorariosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports